module.exports = __webpack_public_path__ + "img/female-child-figure.cdc862e8.svg";